import { useLocation } from 'react-router-dom';
import SeoHead, { serverSeoConfig } from './SeoHead';

// These routes have no page-level SeoHead. Clear the previous page's schema
// and restore their existing Django metadata during client-side navigation.
const standalone = new Set(['cart', 'checkout', 'login', 'register', 'account', 'privacy-policy', 'terms', 'refunds', 'shipping', 'forgot-password', 'reset-password', 'order-confirmation']);
export default function RouteSeo() {
  const { pathname } = useLocation();
  const first = pathname.split('/').filter(Boolean)[0];
  if (!standalone.has(first)) return null;
  const canonical = `https://melanua.com${pathname.endsWith('/') ? pathname : pathname + '/'}`;
  const page = Object.values(serverSeoConfig().pages || {}).find(value => value.canonical === canonical);
  return <SeoHead title={page?.title || 'MELANUA®'} description={page?.description || ''} canonical={canonical}
    robots={page?.noindex || !page ? 'noindex, nofollow' : undefined} />;
}
